import { useNavigate, useParams } from 'react-router-dom';
import { EXTENDED_INTERVAL_UPDATE_DATA } from '../../../../../constants/common';
import { useAppDispatch, useAppSelector } from '../../../../../store/store';
import { useMemo, useRef, useState } from 'react';
import { usePolling } from '../../../../../hooks/usePolling';
import { filterCyclesBySearchQuery } from '../../../../ContractScreensView/utils/filterCyclesBySearchQuery';
import { ICompletedCycles } from '../interfaces/ICompletedCycles';

export const useCompletedCycles = (): ICompletedCycles => {
  const { clientId } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const {
    cycles: {
      getCompletedCyclesByLocation,
    }
  } = useAppDispatch();
  const { completedCycles, searchCycleQuery } = useAppSelector((state) => state.cycles);

  const cycles = useMemo(() => {
    if (!searchCycleQuery) {
      return completedCycles;
    }

    return filterCyclesBySearchQuery(completedCycles, searchCycleQuery);
  }, [completedCycles, searchCycleQuery]);

  const isChangeLoading = useRef(true);

  const fetchDataHandler = async (locationId: string) => {
    try {
      if (!locationId) {
        return;
      }

      if (isChangeLoading.current) {
        setIsLoading(true);
      }

      await getCompletedCyclesByLocation({ locationId });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isChangeLoading.current = false;
    }
  };

  usePolling(() => fetchDataHandler(clientId), EXTENDED_INTERVAL_UPDATE_DATA, [clientId, navigate]);

  return { cycles, isLoading };
}